import React from 'react';
import Highlighter from 'react-highlight-words';

export const HighLightText = ({ text, terms }: { text: string; terms: string[] }) => {
  return <Highlighter searchWords={terms} autoEscape={true} textToHighlight={text} />;
};
